import FileUpload from "../../../../shared/components/FileUpload";

interface UploadFilesProps {
    model: string; // e.g., "materials.MaterialOrder"
    objectId: string;
    objectName?: string; // Display name for the linked object
    customerName?: string; // Customer name if applicable
    customerId?: string; // Customer ID for hyperlink
}

const Upload = (props: UploadFilesProps) => {
    return <FileUpload {...props} />;
};

export default Upload;

